module.exports = __webpack_public_path__ + "img/glassquality_2.d0ff4298.png";